import { fill, t, type StringKey } from '../strings';

/**
 * 🔒 A Bought Out company's successor (piece 10; decision 7690; T3141). The
 * Company page's banner says who bought a company and whom it bought, and each
 * History tile reads one line. 🔨 Nothing moves with the status: links, notes,
 * documents and drafts stay where they are, and piece 33's Script moves them.
 */

/** A company the banner names: its page as a link only where this viewer may read it (decision 2153). */
export interface SuccessionLink {
  id: string;
  name: string;
  route: string | null;
}

/** What the Company banner draws beside the status pill: who bought this company, and the companies it bought. */
export interface CompanySuccession {
  boughtOutBy: SuccessionLink | null;
  formerly: readonly SuccessionLink[];
}

/** A sentence from the lookup with its `{placeholders}` filled, each value taken whole. */
export function successionSentence(key: StringKey, values: Readonly<Record<string, string>>): string {
  return fill(t(key), values);
}

/** A company is Bought Out when its stored status is the member of that name. */
export function isBoughtOut(status: unknown): boolean {
  return status === 'BoughtOut';
}
